import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

export default function WhyPlayGamesOnline() {
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  return (
    <div className={`${themeClass.bgColor} ${themeClass.baseText} min-h-screen`}>

    <div className={`min-h-screen px-6 py-12 ${themeClass.bgColor} ${themeClass.baseText}`}>
      <Helmet>
        <title>Why Play Games Online - BrowserArena</title>
        <meta
          name="description"
          content="Learn why millions choose browser games. No downloads, free to play, and instantly accessible—discover the advantages of online gaming on BrowserArena."
        />
        <link rel="canonical" href="https://browserarena.com/why-online" />
        <meta property="og:title" content="Why Play Games Online - BrowserArena" />
        <meta property="og:description" content="Discover why online games are the top choice: no installs, free fun, instant access on BrowserArena." />
        <meta property="og:url" content="https://browserarena.com/why-online" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className={`max-w-4xl mx-auto rounded-2xl border ${themeClass.borderColor} ${themeClass.overlayBg} shadow-xl shadow-cyan-400/10 backdrop-blur-lg p-8`}>
        <h1 className={`text-4xl font-bold mb-6 tracking-wide ${themeClass.titleColor}`}>
          Why Play Games Online
        </h1>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          In today’s fast-paced world, online games are the ultimate way to relax, connect, and have fun—anytime, anywhere. Unlike console games that require long downloads or hefty installations, browser-based games load instantly with a single click.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          Whether you're into fast-paced shooters, casual puzzles, strategy games, or multiplayer arenas, browser games cover every genre—all within one browser tab. They’re perfect for quick breaks or immersive sessions without the wait.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          Multiplayer capabilities bring an extra layer of excitement. Compete or team up with friends and players around the world, thanks to built-in leaderboards, matchmaking, and live chat features.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          Best of all? Most browser games are free to play. Say goodbye to expensive game purchases—just launch your favorite game and jump right in. With a modern browser and a stable connection, the world of gaming is at your fingertips.
        </p>

        <p className={`text-lg leading-relaxed mb-6 ${themeClass.overlayText}`}>
          At <strong>BrowserArena</strong>, we hand-pick high-quality games that are fun, fast, and frequently updated. No installs. No bloat. Just pure, uninterrupted gameplay.
        </p>

        <div className="mt-8 text-center">
          <p className={`text-base mb-4 ${themeClass.overlayText}`}>
            Learn more about{" "}
            <Link to="/about-browser-games" className={`${themeClass.hoverText} underline`}>
              browser games
            </Link>{" "}
            or explore our{" "}
            <Link to="/html5-games" className={`${themeClass.hoverText} underline`}>
              HTML5 games
            </Link>{" "}
            collection now.
          </p>

          <Link
            to="/"
            className={`inline-block mt-4 px-6 py-2 text-base font-semibold rounded-full border ${themeClass.borderColor} ${themeClass.titleColor} hover:bg-cyan-400/10 hover:text-pink-500 transition`}
          >
            🎮 Browse All Games
          </Link>
        </div>
      </div>
    </div>
    </div>
  );
}
